var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Chip, Typography, useMediaQuery } from '@mui/material';
import { GridActionsCellItem } from '@mui/x-data-grid-premium';
import { DynamicCatalogBuilder } from '../../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder';
import { MuiStack } from '../../../../components';
import { useNavigate } from 'react-router-dom';
import { PSGKeys } from '../services/entity1';
import { IRPagingAPI } from '../services/apiCall';
import InfiniteScroll from '../../../../builderPackage/components/infiniteScroll/infiniteScroll';
var IRsCatalog = function () {
    var navigate = useNavigate();
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var CTAs = [{
            Name: 'Edit',
            DisplayName: 'Edit'
        }, {
            Name: 'View',
            DisplayName: 'View'
        }, {
            Name: 'Print',
            DisplayName: 'Print'
        }, {
            Name: 'Download PDF',
            DisplayName: 'Download PDF'
        }, {
            Name: 'Share',
            DisplayName: 'Share'
        }];
    var columns = [{
            field: 'Document name',
            headerName: 'Document name',
            headerAlign: 'center',
            minWidth: 100
        }, {
            type: 'string',
            field: 'Document date',
            headerName: 'Document date',
            minWidth: 150,
            flex: 1
        }, {
            field: 'Group name & code',
            headerName: 'Group name & code',
            minWidth: 180,
            renderCell: function (params) {
                var _params$row$GroupName, _params$row, _params$row$GroupCode, _params$row2;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'column'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption"
                }, (_params$row$GroupName = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.GroupName) !== null && _params$row$GroupName !== void 0 ? _params$row$GroupName : ""), /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: 'secondary'
                }, (_params$row$GroupCode = params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.GroupCode) !== null && _params$row$GroupCode !== void 0 ? _params$row$GroupCode : "")));
            }
        }, {
            field: 'Part name & code',
            headerName: 'Part name & code',
            minWidth: 180,
            renderCell: function (params) {
                var _params$row$PartName, _params$row3, _params$row$PartCode, _params$row4;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'column'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption"
                }, (_params$row$PartName = params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.PartName) !== null && _params$row$PartName !== void 0 ? _params$row$PartName : ""), /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: 'secondary'
                }, (_params$row$PartCode = params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.PartCode) !== null && _params$row$PartCode !== void 0 ? _params$row$PartCode : "")));
            }
        }, {
            field: 'Defect description & code',
            headerName: 'Defect description & code',
            minWidth: 180,
            renderCell: function (params) {
                var _params$row$DefectNam, _params$row5, _params$row$DefectCod, _params$row6;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'column'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption"
                }, (_params$row$DefectNam = params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.DefectName) !== null && _params$row$DefectNam !== void 0 ? _params$row$DefectNam : ""), /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "caption",
                    color: 'secondary'
                }, (_params$row$DefectCod = params === null || params === void 0 || (_params$row6 = params.row) === null || _params$row6 === void 0 ? void 0 : _params$row6.DefectCode) !== null && _params$row$DefectCod !== void 0 ? _params$row$DefectCod : "")));
            }
        }, {
            field: 'Owner',
            headerName: 'Owner',
            minWidth: 180
        }, {
            field: 'CategoryName',
            headerName: 'Category',
            minWidth: 180
        }, {
            field: 'PriorityName',
            headerName: 'Priority',
            minWidth: 180
        }, {
            field: 'Assigned to',
            headerName: 'Assigned to',
            minWidth: 180
        }, {
            field: 'Assigned by',
            headerName: 'Assigned by',
            minWidth: 180
        }, {
            field: 'Intensity',
            headerName: 'Intensity',
            minWidth: 180
        }, {
            field: 'Ageing',
            headerName: 'Ageing',
            minWidth: 180
        }, {
            field: 'Source',
            headerName: 'Source',
            minWidth: 180
        }, {
            field: 'PSG remarks',
            headerName: 'PSG remarks',
            minWidth: 180
        }, {
            field: 'Status',
            headerName: 'Status',
            minWidth: 180,
            renderCell: function (params) {
                return /*#__PURE__*/ React.createElement(Chip, {
                    color: "info",
                    shape: "rounded",
                    label: "Submitted to ASM"
                });
            }
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _this = this;
                return CTAs === null || CTAs === void 0 ? void 0 : CTAs.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    label: data.DisplayName,
                    showInMenu: true,
                    onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            console.log('data.name', data === null || data === void 0 ? void 0 : data.Name);
                            if ((data === null || data === void 0 ? void 0 : data.Name) === 'Edit') {
                                navigate('/iRs/editIR');
                            }
                            return [2 /*return*/];
                        });
                    }); }
                }); });
            }
        }];
    return lgMode ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: PSGKeys.PagingIR + 'Open',
        pagingAPIRequest: {
        //   DataRange: value?.DataRange,
        //   FromDate: value?.DataRange ? value?.FromDate : undefined,
        //   ToDate: value?.DataRange ? value?.ToDate : undefined,
        //   search: value?.search,
        //   status: value?.SelectedButton
        },
        getPagingData: IRPagingAPI,
        columns: columns,
        dataGridProps: {
            sx: {
                marginX: 3
            },
            disableColumnSelector: true,
            cellSelection: false,
            disableColumnPinning: false,
            initialState: {
                pinnedColumns: {
                    left: ["DocumentName"],
                    right: ["Status", 'Actions']
                },
                density: "standard"
            }
        }
    })) : /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiCall: IRPagingAPI,
        apiKey: PSGKeys.PagingIR + 'Open',
        apiRequest: {
        // DataRange: value?.DataRange,
        // FromDate: value?.DataRange ? value?.FromDate : undefined,
        // ToDate: value?.DataRange ? value?.ToDate : undefined,
        // search: value?.search,
        // status:
        //   value?.SelectedButton === "Open" ? null : value?.SelectedButton,
        }
        //   hasMore={hasMore}
        ,
        gridContainerProps: {
            spacing: 2,
            p: 2
        },
        gridItemProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4
        }
        //   elements={columns}
    });
};
export default IRsCatalog;
